import { getSelector, generateRandomNumber } from '../helpers/helpers';

    let folderLocation = {
        rootFolder: window.immiObj.prefixUrl,
        VisitorsToUSA: 'visitors-to-usa',
        StudentVisa: 'international-student',
        ExchangeVisitor: 'exchange-visitor',
        GroupTravel: 'group-travel',
        MultiTrip: 'multi-trip',
        NewImmigrant: 'new-immigrants',
        SchengenVisa: 'schengen-visa',
        TravelOutside: 'travel-outside-usa',
        BusinessVisa: 'visitors-to-usa/business-ads',
        YoungAdult: 'visitors-to-usa/young-adult-mix',
        ScoutAI: 'scout-ai',
        StablePreEx: 'stable-preex',
        Flight: 'flight',
        Marine: 'marine',
        TripCancellation: 'trip-cancellation',
        India: 'india'
    };

    let insubuyPath = {
        rootPath: 'https://www.insubuy.com/',
        en: {
            VisitorsToUSA: 'visitors-insurance',
            StudentVisa: 'international-student-insurance',
            ExchangeVisitor: 'j1-visa-health-insurance',
            GroupTravel: 'group-travel-medical-insurance',
            MultiTrip: 'multi-trip-travel-insurance',
            NewImmigrant: 'new-immigrants-health-insurance',
            SchengenVisa: 'schengen-visa-insurance',
            TravelOutside: 'travel-health-insurance',
            BusinessVisa: 'visitors-insurance',
            YoungAdult: 'visitors-insurance',
            ScoutAI: 'insurance-assistant',
            StablePreEx: 'pre-existing-condition-coverage-guide',
            Flight: 'flight-insurance',
            Marine: 'marine-crew-health-insurance',
            TripCancellation: 'travel-insurance',
            India: 'india-travel-insurance'
        },
        es: {
            VisitorsToUSA: 'seguro-medico-para-visitantes-a-los-estados-unidos',
            StudentVisa: 'seguro-de-estudiante-internacional',
            ExchangeVisitor: 'seguro-j1-visa',
            GroupTravel: 'group-travel-medical-insurance',
            MultiTrip: 'multi-trip-travel-insurance',
            NewImmigrant: 'seguro-de-salud-para-inmigrantes-nuevos',
            SchengenVisa: 'seguro-para-visado-schengen',
            TravelOutside: 'seguro-de-salud-de-viaje',
            BusinessVisa: 'seguro-medico-para-visitantes-a-los-estados-unidos',
            YoungAdult: 'seguro-medico-para-visitantes-a-los-estados-unidos',
            ScoutAI: 'insurance-assistant',
            StablePreEx: 'guia-de-cobertura-de-condiciones-preexistentes',
            TripCancellation: 'travel-insurance'
        },
        zh: {
            VisitorsToUSA: 'meiguo-lvyou-yiliao-baoxian',
            StudentVisa: 'guoji-xuesheng-baoxian',
            ExchangeVisitor: 'j1-qianzheng-baoxian',
            GroupTravel: 'tuanti-lvyou-yiliao-baoxian',
            MultiTrip: 'multi-trip-travel-insurance',
            NewImmigrant: 'xin-yimin-jiankang-baoxian',
            SchengenVisa: 'shengen-qianzheng-baoxian',
            TravelOutside: 'lvyou-jiankang-baoxian',
            BusinessVisa: 'meiguo-lvyou-yiliao-baoxian',
            YoungAdult: 'meiguo-lvyou-yiliao-baoxian',
            ScoutAI: 'insurance-assistant',
            StablePreEx: 'yuanyou-bingzheng-baozhang-zhinan',
            TripCancellation: 'travel-insurance'
        }
    };

    // Scout AI is its own banner section: its own artwork folder and its own destination page
    // (insubuy.com/insurance-assistant/). It is not an insurance category, so it is never picked
    // in WordPress on its own - instead it rides along in the rotation of the sections below.
    let scoutAiSection = 'ScoutAI';
    let scoutAiHostSections = ['VisitorsToUSA', 'BusinessVisa', 'YoungAdult'];

    // Stable PreEx works the same way as Scout AI, linking to the pre-existing condition coverage
    // guide on insubuy.com, and rides along with the same visitors-to-usa family of sections.
    let stablePreexSection = 'StablePreEx';
    let stablePreexHostSections = ['VisitorsToUSA', 'BusinessVisa', 'YoungAdult'];

    let selectedCategories = [];
    let categoryAds = window.immiObj.categoryAdsList && typeof window.immiObj.categoryAdsList === 'string' ? window.immiObj.categoryAdsList.split(',') : window.immiObj.categoryAdsList && Array.isArray(window.immiObj.categoryAdsList) ? window.immiObj.categoryAdsList : [];
    let language = 'en';
    if (window.immiObj.currentLanguage === 'Chinese' || (window.immiLang && window.immiLang.currentLangCode == 'zh')) {
        language = 'zh';    
    } else if(window.immiObj.currentLanguage === 'Spanish') {
        language = 'es';
    }
    
    for (let i = 0 ; i < categoryAds.length ; i++) {
        if (categoryAds[i] === 'Visitors To USA' || categoryAds[i] === 'VisitorsToUSA') {
            selectedCategories.push('VisitorsToUSA');
        } else if (categoryAds[i] === 'Student Visa (F1/F2)' || categoryAds[i] === 'StudentVisa') {
            selectedCategories.push('StudentVisa');
        } else if (categoryAds[i] === 'Exchange Visitor (J1/J2)' || categoryAds[i] === 'ExchangeVisitor') {
            selectedCategories.push('ExchangeVisitor');
        } else if (categoryAds[i] === 'Group Travel' || categoryAds[i] === 'GroupTravel') {
            selectedCategories.push('GroupTravel');
        } else if (categoryAds[i] === 'Multi Trip' || categoryAds[i] === 'MultiTrip') {
            selectedCategories.push('MultiTrip');
        } else if (categoryAds[i] === 'New Immigrants' || categoryAds[i] === 'NewImmigrant') {
            selectedCategories.push('NewImmigrant');
        } else if (categoryAds[i] === 'Schengen Visa' || categoryAds[i] === 'SchengenVisa') {
            selectedCategories.push('SchengenVisa');
        } else if (categoryAds[i] === 'Travel Outside USA' || categoryAds[i] === 'TravelOutside') {
            selectedCategories.push('TravelOutside');
        } else if (categoryAds[i] === 'Business Visa (Visitors Visa)' || categoryAds[i] === 'BusinessVisa') {
            selectedCategories.push('BusinessVisa');
        } else if (categoryAds[i] === 'Young Adult (Visitors Visa)' || categoryAds[i] === 'YoungAdult') {
            selectedCategories.push('YoungAdult');
        } else if (categoryAds[i] === 'Flight' || categoryAds[i] === 'Flight') {
            selectedCategories.push('Flight');
        } else if (categoryAds[i] === 'Marine') {
            selectedCategories.push('Marine');
        } else if (categoryAds[i] === 'Trip Cancellation' || categoryAds[i] === 'TripCancellation') {
            selectedCategories.push('TripCancellation');
        } else if (categoryAds[i] === 'India') {
            selectedCategories.push('India');
        } else if (categoryAds[i] === 'Scout AI' || categoryAds[i] === 'ScoutAI') {
            selectedCategories.push('ScoutAI');
        } else if (categoryAds[i] === 'Stable PreEx' || categoryAds[i] === 'StablePreEx') {
            selectedCategories.push('StablePreEx');
        }
    }
    if(selectedCategories.length === 0) {
        selectedCategories = ['VisitorsToUSA', 'StudentVisa', 'ExchangeVisitor'];
    }

    function ListOfEnglishBanners () {

        // Visitors To USA
        this.VisitorsToUSA = {
            $desktop_vertical: ['visitors_to_usa-v-1.jpg', 'visitors_to_usa-v-2.jpg', 'visitors_to_usa-v-3.gif', 'visitors_to_usa-v-4.jpg', 'visitors_to_usa-v-5.jpg', 'visitors_to_usa-v-6.jpg', 'visitors_to_usa-v-7.jpg', 'visitors_to_usa-v-8.jpg'],
            $desktop_horizontal: ['visitors_to_usa-h-1.jpg', 'visitors_to_usa-h-2.gif' ,'visitors_to_usa-h-3.gif', 'visitors_to_usa-h-4.gif', 'visitors_to_usa-h-5.jpg', 'visitors_to_usa-h-6.jpg', 'visitors_to_usa-h-7.jpg', 'visitors_to_usa-h-8.jpg', 'visitors_to_usa-h-9.jpg'],
            $desktop_square: ['visitors_to_usa-s-1.jpg', 'visitors_to_usa-s-2.gif', 'visitors_to_usa-s-3.gif', 'visitors_to_usa-s-4.jpg', 'visitors_to_usa-s-5.jpg', 'visitors_to_usa-s-6.jpg', 'visitors_to_usa-s-7.jpg', 'visitors_to_usa-s-8.jpg'],
            $mobile_top: ['visitors_to_usa-m-t-1.gif', 'visitors_to_usa-m-t-2.gif', 'visitors_to_usa-m-t-3.jpg', 'visitors_to_usa-m-t-4.jpg', 'visitors_to_usa-m-t-5.jpg', 'visitors_to_usa-m-t-6.jpg', 'visitors_to_usa-m-t-7.jpg', 'visitors_to_usa-m-t-8.jpg'],
            $mobile_bottom: ['visitors_to_usa-m-b-1.jpg', 'visitors_to_usa-m-b-2.gif', 'visitors_to_usa-m-b-3.jpg', 'visitors_to_usa-m-b-4.jpg', 'visitors_to_usa-m-b-5.jpg', 'visitors_to_usa-m-b-6.jpg', 'visitors_to_usa-m-b-7.jpg']
        };

        // Scout AI - links to insubuy.com/insurance-assistant/, mixed into the rotation of the
        // sections listed in scoutAiHostSections rather than replacing any of their banners.
        this.ScoutAI = {
            $desktop_vertical: ['scout-ai-160x600-v1.png', 'scout-ai-160x600-v2.png', 'scout-ai-160x600-v3.png', 'scout-ai-160x600-v4.png'],
            $desktop_horizontal: ['scout-ai-970x90-v1.png', 'scout-ai-970x90-v2.png', 'scout-ai-970x90-v3.png', 'scout-ai-970x90-v4.png'],
            $desktop_square: ['scout-ai-250x250-v1.png', 'scout-ai-250x250-v2.png', 'scout-ai-250x250-v3.png', 'scout-ai-250x250-v4.png'],
            $mobile_top: ['scout-ai-300x50x2-v1.png', 'scout-ai-300x50x2-v2.png', 'scout-ai-300x50x2-v3.png', 'scout-ai-300x50x2-v4.png'],
            $mobile_bottom: ['scout-ai-336x280-v1.png', 'scout-ai-336x280-v2.png', 'scout-ai-336x280-v3.png', 'scout-ai-336x280-v4.png']
        };

        // Stable PreEx - links to insubuy.com/pre-existing-condition-coverage-guide/, mixed into the
        // rotation of the sections listed in stablePreexHostSections.
        this.StablePreEx = {
            $desktop_vertical: ['stable-preex-160x600-v1.png'],
            $desktop_horizontal: ['stable-preex-970x90-v1.png'],
            $desktop_square: ['stable-preex-250x250-v1.png'],
            $mobile_top: ['stable-preex-300x50-v1.png'],
            $mobile_bottom: ['stable-preex-336x280-v1.png']
        };

        // Student Visa
        this.StudentVisa = {
            $desktop_vertical: ['student-v-1.jpg', 'student-v-2.jpg', 'student-v-3.gif'],
            $desktop_horizontal: ['student-h-1.jpg', 'student-h-2.jpg', 'student-h-3.gif'],
            $desktop_square: ['student-s-1.jpg', 'student-s-2.jpg', 'student-s-3.jpg'],
            $mobile_top: ['student-m-t-1.png', 'student-m-t-2.gif', 'student-m-t-3.gif'],
            $mobile_bottom: ['student-m-b-1.jpg', 'student-m-b-2.jpg', 'student-m-b-3.jpg']
        };

        // Exchange Visitor
        this.ExchangeVisitor = {
            $desktop_vertical: ['j1_visa-v-1.jpg', 'j1_visa-v-2.gif', 'j1_visa-v-3.gif'],
            $desktop_horizontal: ['j1_visa-h-1.jpg', 'j1_visa-h-2.gif', 'j1_visa-h-3.gif'],
            $desktop_square: ['j1_visa-s-1.jpg', 'j1_visa-s-2.jpg'],
            $mobile_top: ['j1_visa-m-t-1.jpg', 'j1_visa-m-t-2.gif', 'j1_visa-m-t-3.gif'],
            $mobile_bottom: ['j1_visa-m-b-1.jpg', 'j1_visa-m-b-2.gif', 'j1_visa-m-b-3.gif']
        };

        // Group Travel
        this.GroupTravel = {
            $desktop_vertical: ['group_travel-v-1.jpg', 'group_travel-v-2.jpg', 'group_travel-v-3.jpg'],
            $desktop_horizontal: ['group_travel-h-1.jpg', 'group_travel-h-2.jpg', 'group_travel-h-2.jpg'],
            $desktop_square: ['group_travel-s-1.jpg', 'group_travel-s-2.jpg'],
            $mobile_top: ['group_travel-m-t-1.jpg', 'group_travel-m-t-2.gif', 'group_travel-m-t-3.gif'],
            $mobile_bottom: ['group_travel-m-b-1.jpg', 'group_travel-m-b-2.jpg', 'group_travel-m-b-3.jpg']
        };

        // Multi Trip
        this.MultiTrip = {
            $desktop_vertical: ['multitrip-v-1.jpg'],
            $desktop_horizontal: ['multitrip-h-1.jpg'],
            $desktop_square: ['multitrip-s-1.jpg'],
            $mobile_top: ['multitrip-m-t-1.jpg'],
            $mobile_bottom: ['multitrip-m-b-1.jpg']
        };
        

        this.NewImmigrant = {
            $desktop_vertical: ['new_immigrants-v-1.gif', 'new_immigrants-v-2.jpg', 'new_immigrants-v-3.gif'],
            $desktop_horizontal: ['new_immigrants-h-1.gif', 'new_immigrants-h-2.gif', 'new_immigrants-h-3.gif'],
            $desktop_square: ['new_immigrants-s-1.gif', 'new_immigrants-s-2.gif'],
            $mobile_top: ['new_immigrants-m-t-1.gif', 'new_immigrants-m-t-2.gif'],
            $mobile_bottom: ['new_immigrants-m-b-1.gif', 'new_immigrants-m-b-2.gif']
        };

        this.India = {
            $desktop_vertical: [],
            $desktop_horizontal: ['india-h-1.jpg'],
            $desktop_square: [],
            $mobile_top: ['india-m-t-2.gif'],
            $mobile_bottom: []
        };

        // Schengen Visa
        this.SchengenVisa = {
            $desktop_vertical: ['schengen_visa-v-1.gif', 'schengen_visa-v-2.jpg', 'schengen_visa-v-3.jpg'],
            $desktop_horizontal: ['schengen_visa-h-1.gif', 'schengen_visa-h-2.gif', 'schengen_visa-h-3.gif', 'schengen_visa-h-4.jpg'],
            $desktop_square: ['schengen_visa-s-1.jpg', 'schengen_visa-s-2.gif', 'schengen_visa-s-3.gif'],
            $mobile_top: ['schengen_visa-m-t-1.jpg', 'schengen_visa-m-t-2.gif', 'schengen_visa-m-t-3.gif'],
            $mobile_bottom: ['schengen_visa-m-b-1.jpg', 'schengen_visa-m-b-2.gif', 'schengen_visa-m-b-3.gif']
        };

        // Travel Outside USA
        this.TravelOutside = {
            $desktop_vertical: ['travel_insurance_outside_usa-v-1.gif', 'travel_insurance_outside_usa-v-2.jpg', 'travel_insurance_outside_usa-v-3.jpg', 'travel_insurance_outside_usa-v-4.jpg'],
            $desktop_horizontal: ['travel_insurance_outside_usa-h-1.gif', 'travel_insurance_outside_usa-h-2.gif', 'travel_insurance_outside_usa-h-3.gif', 'travel_insurance_outside_usa-h-4.jpg'],
            $desktop_square: ['travel_insurance_outside_usa-s-1.gif', 'travel_insurance_outside_usa-s-2.gif', 'travel_insurance_outside_usa-s-3.gif', 'travel_insurance_outside_usa-s-4.gif', 'travel_insurance_outside_usa-s-5.jpg'],
            $mobile_top: ['travel_insurance_outside_usa-m-t-1.gif', 'travel_insurance_outside_usa-m-t-2.gif', 'travel_insurance_outside_usa-m-t-3.jpg'],
            $mobile_bottom: ['travel_insurance_outside_usa-m-b-1.gif', 'travel_insurance_outside_usa-m-b-2.gif', 'travel_insurance_outside_usa-m-b-3.gif', 'travel_insurance_outside_usa-m-b-4.gif', 'travel_insurance_outside_usa-m-b-5.jpg']
        };
        
        // Business Visa
        this.BusinessVisa = {
            $desktop_vertical: ['visitors_to_usa_business-v-1.gif', 'visitors_to_usa_business-v-2.jpg', 'visitors_to_usa_business-v-3.jpg'],
            $desktop_horizontal: ['visitors_to_usa_business-h-1.gif', 'visitors_to_usa_business-h-2.jpg', 'visitors_to_usa_business-h-3.gif', 'visitors_to_usa_business-h-4.gif'],
            $desktop_square: ['visitors_to_usa_business-s-1.jpg'],
            $mobile_top: ['visitors_to_usa_business-m-t-1.gif', 'visitors_to_usa_business-m-t-2.gif', 'visitors_to_usa_business-m-t-3.jpg'],
            $mobile_bottom: ['visitors_to_usa_business-m-b-1.jpg', 'visitors_to_usa_business-m-b-2.jpg', 'visitors_to_usa_business-m-b-3.jpg']
        };
        
        // Young Adult
        this.YoungAdult = {
            $desktop_vertical: ['visitors_to_usa_young_adult_mix-v-1.jpg', 'visitors_to_usa_young_adult_mix-v-2.gif', 'visitors_to_usa_young_adult_mix-v-3.jpg'],
            $desktop_horizontal: ['visitors_to_usa_young_adult_mix-h-1.gif', 'visitors_to_usa_young_adult_mix-h-2.jpg', 'visitors_to_usa_young_adult_mix-h-3.gif', 'visitors_to_usa_young_adult_mix-h-4.gif'],
            $desktop_square: ['visitors_to_usa_young_adult_mix-s-1.jpg'],
            // Fixed: this list pointed at two images that don't exist in the folder, so some visitors saw a
            // blank mobile banner. Banner 2 is a .gif (not .jpg), and banner 4 was never uploaded, so it's removed.
            $mobile_top: ['visitors_to_usa_young_adult_mix-m-t-1.jpg', 'visitors_to_usa_young_adult_mix-m-t-2.gif', 'visitors_to_usa_young_adult_mix-m-t-3.gif'],
            $mobile_bottom: ['visitors_to_usa_young_adult_mix-m-b-1.jpg', 'visitors_to_usa_young_adult_mix-m-b-2.jpg', 'visitors_to_usa_young_adult_mix-m-b-3.jpg']
        };

        this.Flight = {
            $desktop_vertical: ['flight-v-1.jpg'],
            $desktop_horizontal: ['flight-h-1.jpg'],
            $desktop_square: ['flight-s-1.jpg'],
            $mobile_top: ['flight-m-t-1.jpg'],
            $mobile_bottom: ['flight-m-b-1.jpg']
        }

        // Marine
        this.Marine = {
            $desktop_vertical: ['marine-crew-v-1.jpg', 'marine-crew-v-2.jpg', 'marine-crew-v-3.jpg'],
            $desktop_horizontal: ['marine-crew-h-1.jpg', 'marine-crew-h-2.jpg', 'marine-crew-h-3.jpg'],
            $desktop_square: ['marine-crew-s-1.jpg', 'marine-crew-s-2.jpg', 'marine-crew-s-3.jpg'],
            $mobile_top: ['marine-crew-m-t-1.gif', 'marine-crew-m-t-2.jpg', 'marine-crew-m-t-3.jpg'],
            $mobile_bottom: ['marine-crew-m-b-1.jpg', 'marine-crew-m-b-2.jpg', 'marine-crew-m-b-3.jpg']
        }

        // Trip Cancellation
        this.TripCancellation = {
            $desktop_vertical: ['travel_insurance_banner1_v.jpg', 'travel_insurance_banner3_v.jpg', 'travel_insurance_banner4_v.gif', 'travel_insurance_banner5_v.jpg', 'travel_insurance_banner7_v.jpg', 'travel_insurance_banner8_v.jpg', 'travel_insurance_banner9_v.jpg'],
            $desktop_horizontal: ['travel_insurance_h-1.jpg', 'travel_insurance_h-2.jpg', 'travel_insurance_h-3.gif', 'travel_insurance_h-4.jpg', 'travel_insurance_h-5.jpg', 'travel_insurance_h-6.jpg', 'travel_insurance_h-7.jpg'],
            $desktop_square: ['travel_insurance_outside_usa_s-1.gif', 'travel_insurance_s-1.jpg', 'travel_insurance_s-2.jpg'],
            $mobile_top: ['travel_insurance_m-t-1.gif', 'travel_insurance_m-t-2.gif'],
            $mobile_bottom: ['travel_insurance_m-b-1.jpg', 'travel_insurance_m-b-2.gif', 'travel_insurance_m-b-3.jpg'],
        }
    }

    function ListOfSpanishBanners () {

        // Visitors To USA
        this.VisitorsToUSA = {
            $desktop_vertical: ['visitors_to_usa-v-1.jpg', 'visitors_to_usa-v-2.gif', 'visitors_to_usa-v-3.jpg'],
            $desktop_horizontal: ['visitors_to_usa-h-1.jpg', 'visitors_to_usa-h-2.gif' ,'visitors_to_usa-h-3.gif'],
            $desktop_square: ['visitors_to_usa-s-1.jpg', 'visitors_to_usa-s-2.gif', 'visitors_to_usa-s-3.gif', 'visitors_to_usa-s-4.jpg', 'visitors_to_usa-s-5.jpg', 'visitors_to_usa-s-6.gif'],
            $mobile_top: ['visitors_to_usa-m-t-1.gif', 'visitors_to_usa-m-t-2.jpg', 'visitors_to_usa-m-t-3.gif'],
            $mobile_bottom: ['visitors_to_usa-m-b-1.jpg', 'visitors_to_usa-m-b-2.gif', 'visitors_to_usa-m-b-3.gif']
        };

        // Student Visa
        this.StudentVisa = {
            $desktop_vertical: ['student-v-1.jpg', 'student-v-2.jpg', 'student-v-3.gif'],
            $desktop_horizontal: ['student-h-1.jpg', 'student-h-2.jpg', 'student-h-3.gif'],
            $desktop_square: ['student-s-1.jpg', 'student-s-2.jpg', 'student-s-3.gif', 'student-s-4.jpg','student-s-5.gif', 'student-s-6.gif'],
            $mobile_top: ['student-m-t-1.jpg', 'student-m-t-2.gif', 'student-m-t-3.gif'],
            $mobile_bottom: ['student-m-b-1.jpg', 'student-m-b-2.jpg', 'student-m-b-3.jpg']
        };

        // Exchange Visitor
        this.ExchangeVisitor = {
            $desktop_vertical: ['j1_visa-v-1.png', 'j1_visa-v-2.gif', 'j1_visa-v-3.gif'],
            $desktop_horizontal: ['j1_visa-h-1.png', 'j1_visa-h-2.gif', 'j1_visa-h-3.gif'],
            $desktop_square: ['j1_visa-s-1.jpg', 'j1_visa-s-2.gif', 'j1_visa-s-3.gif', 'j1_visa-s-4.jpg', 'j1_visa-s-5.gif', 'j1_visa-s-6.gif'],
            $mobile_top: ['j1_visa-m-t-1.jpg', 'j1_visa-m-t-2.gif', 'j1_visa-m-t-3.gif'],
            $mobile_bottom: ['j1_visa-m-b-1.jpg', 'j1_visa-m-b-2.gif', 'j1_visa-m-b-3.gif']
        };

        // Group Travel
        this.GroupTravel = {
            $desktop_vertical: ['group_travel-v-1.jpg', 'group_travel-v-2.jpg'],
            $desktop_horizontal: ['group_travel-h-1.jpg', 'group_travel-h-2.jpg'],
            $desktop_square: ['group_travel-s-1.jpg', 'group_travel-s-2.jpg'],
            $mobile_top: ['group_travel-m-t-1.gif', 'group_travel-m-t-2.gif'],
            $mobile_bottom: ['group_travel-m-b-1.jpg', 'group_travel-m-b-2.jpg']
        };

        // Multi Trip
        this.MultiTrip = {
            $desktop_vertical: ['multitrip-v-1.jpg'],
            $desktop_horizontal: ['multitrip-h-1.jpg'],
            $desktop_square: ['multitrip-s-1.jpg'],
            $mobile_top: ['multitrip-m-t-1.jpg'],
            $mobile_bottom: ['multitrip-m-b-1.jpg']
        };

        // New Immigrants
        this.NewImmigrant = {
            $desktop_vertical: ['new_immigrant_v-1.jpg', 'new_immigrant_v-2.jpg', 'new_immigrant_v-3.gif'],
            $desktop_horizontal: ['new_immigrants_h-1.jpg', 'new_immigrants_h-2.gif', 'new_immigrants_h-3.jpg'],
            $desktop_square: ['new_immigrants_s-1.jpg', 'new_immigrants_s-2.jpg'],
            $mobile_top: ['new_immigrants_m-t-1.gif', 'new_immigrants_m-t-2.gif'],
            $mobile_bottom: ['new_immigrants_m-b-1.jpg', 'new_immigrants_m-b-2.jpg']
        };

        // Schengen Visa
        this.SchengenVisa = {
            $desktop_vertical: ['schengen_visa-v-1.jpg', 'schengen_visa-v-2.jpg'],
            $desktop_horizontal: ['schengen_visa-h-1.jpg', 'schengen_visa-h-2.gif', 'schengen_visa-h-3.jpg'],
            $desktop_square: ['schengen_visa-s-1.jpg', 'schengen_visa-s-2.jpg'],
            $mobile_top: ['schengen_visa-m-t-1.gif', 'schengen_visa-m-t-2.gif'],
            $mobile_bottom: ['schengen_visa-m-b-1.jpg', 'schengen_visa-m-b-2.jpg']
        };

        // Travel Outside USA
        this.TravelOutside = {
            $desktop_vertical: ['travel_insurance_outside_usa-v-1.jpg', 'travel_insurance_outside_usa-v-2.jpg', 'travel_insurance_outside_usa-v-3.jpg'],
            $desktop_horizontal: ['travel_insurance_outside_usa-h-1.jpg', 'travel_insurance_outside_usa-h-2.gif', 'travel_insurance_outside_usa-h-3.jpg'],
            $desktop_square: ['travel_insurance_outside_usa-s-1.jpg', 'travel_insurance_outside_usa-s-2.jpg', 'travel_insurance_outside_usa-s-3.gif', 'travel_insurance_outside_usa-s-4.jpg'],
            $mobile_top: ['travel_insurance_outside_usa-m-t-1.gif', 'travel_insurance_outside_usa-m-t-2.gif'],
            $mobile_bottom: ['travel_insurance_outside_usa-m-b-1.jpg', 'travel_insurance_outside_usa-m-b-2.jpg', 'travel_insurance_outside_usa-m-b-3.jpg']
        };
        
        // Business Visa
        this.BusinessVisa = {
            $desktop_vertical: [],
            $desktop_horizontal: [],
            $desktop_square: [],
            $mobile_top: [],
            $mobile_bottom: []
        };
        
        // Young Adult
        this.YoungAdult = {
            $desktop_vertical: [],
            $desktop_horizontal: [],
            $desktop_square: [],
            $mobile_top: [],
            $mobile_bottom: []
        };

        // Scout AI - no Spanish artwork yet
        this.ScoutAI = {
            $desktop_vertical: [],
            $desktop_horizontal: [],
            $desktop_square: [],
            $mobile_top: [],
            $mobile_bottom: []
        };

        // Stable PreEx
        this.StablePreEx = {
            $desktop_vertical: ['stable-preex-160x600-v1.png'],
            $desktop_horizontal: ['stable-preex-970x90-v1.png'],
            $desktop_square: ['stable-preex-250x250-v1.png'],
            $mobile_top: ['stable-preex-300x50-v1.png'],
            $mobile_bottom: ['stable-preex-336x280-v1.png']
        };

        //flight
        this.Flight = {
            $desktop_vertical: ['flight-v-1.jpg'],
            $desktop_horizontal: ['flight-h-1.jpg'],
            $desktop_square: ['flight-s-1.jpg'],
            $mobile_top: ['flight-m-t-1.jpg'],
            $mobile_bottom: ['flight-m-b-1.jpg']
        }

        this.Marine = {
            $desktop_vertical: [],
            $desktop_horizontal: [],
            $desktop_square: [],
            $mobile_top: [],
            $mobile_bottom: []
        }

        // Trip Cancellation
        this.TripCancellation = {
            $desktop_vertical: [],
            $desktop_horizontal: [],
            $desktop_square: [],
            $mobile_top: [],
            $mobile_bottom: []
        }
    }

    function ListOfChineseBanners () {

        // Visitors To USA
        this.VisitorsToUSA = {
            $desktop_vertical: ['visitors_to_usa-v-1.jpg', 'visitors_to_usa-v-2.gif', 'visitors_to_usa-v-3.jpg'],
            $desktop_horizontal: ['visitors_to_usa-h-1.gif', 'visitors_to_usa-h-2.gif', 'visitors_to_usa-h-3.gif'],
            $desktop_square: ['visitors_to_usa-s-1.gif', 'visitors_to_usa-s-2.gif', 'visitors_to_usa-s-3.gif'],
            $mobile_top: ['visitors_to_usa-m-t-1.jpg', 'visitors_to_usa-m-t-2.gif', 'visitors_to_usa-m-t-3.gif'],
            $mobile_bottom: ['visitors_to_usa-m-b-1.gif', 'visitors_to_usa-m-b-2.jpg']
        };        

        // Student Visa
        this.StudentVisa = {
            $desktop_vertical: ['student-v-1.png', 'student-v-2.jpg', 'student-v-3.gif'],
            $desktop_horizontal: ['student-h-1.png', 'student-h-2.jpg', 'student-h-3.gif'],
            $desktop_square: ['student-s-1.jpg', 'student-s-2.jpg', 'student-s-3.jpg', 'student-s-4.jpg'],
            $mobile_top: ['student-m-t-1.png', 'student-m-t-2.gif', 'student-m-t-3.gif'],
            $mobile_bottom: ['student-m-b-1.jpg', 'student-m-b-2.jpg', 'student-m-b-3.jpg']
        };        

        // Exchange Visitor
        this.ExchangeVisitor = {
            $desktop_vertical: ['j1_visa-v-1.jpg', 'j1_visa-v-2.gif', 'j1_visa-v-3.gif'],
            $desktop_horizontal: ['j1_visa-h-1.jpg', 'j1_visa-h-2.gif', 'j1_visa-h-3.gif'],
            $desktop_square: ['j1_visa-s-1.jpg', 'j1_visa-s-2.jpg'],
            $mobile_top: ['j1_visa-m-t-1.jpg', 'j1_visa-m-t-2.jpg', 'j1_visa-m-t-3.gif', 'j1_visa-m-t-4.gif'],
            $mobile_bottom: ['j1_visa-m-b-1.jpg']
        };        

        // Group Travel
        this.GroupTravel = {
            $desktop_vertical: ['group_travel-v-1.jpg', 'group_travel-v-2.jpg', 'group_travel-v-3.jpg'],
            $desktop_horizontal: ['group_travel-h-1.jpg', 'group_travel-h-2.jpg', 'group_travel-h-3.jpg'],
            $desktop_square: ['group_travel-s-1.jpg', 'group_travel-s-2.jpg', 'group_travel-s-3.jpg'],
            $mobile_top: ['group_travel-m-t-1.gif', 'group_travel-m-t-2.gif', 'group_travel-m-t-3.jpg'],
            $mobile_bottom: ['group_travel-m-b-1.jpg', 'group_travel-m-b-2.jpg', 'group_travel-m-b-3.jpg']
        };

        // Multi Trip
        this.MultiTrip = {
            $desktop_vertical: ['multitrip-v-1.jpg'],
            $desktop_horizontal: ['multitrip-h-1.jpg'],
            $desktop_square: ['multitrip-s-1.jpg'],
            $mobile_top: ['multitrip-m-t-1.jpg'],
            $mobile_bottom: ['multitrip-m-b-1.jpg']
        };

        // New Immigrants
        this.NewImmigrant = {
            $desktop_vertical: ['new_immigrant-v-1.jpg', 'new_immigrant-v-2.jpg', 'new_immigrant-v-3.gif'],
            $desktop_horizontal: ['new_immigrant-h-1.jpg', 'new_immigrant-h-2.gif', 'new_immigrant-h-3.jpg'],
            $desktop_square: ['new_immigrant-s-1.jpg', 'new_immigrant-s-2.jpg'],
            $mobile_top: ['new_immigrant-m-t-1.gif', 'new_immigrant-m-t-1.gif'],
            $mobile_bottom: ['new_immigrant-m-b-1.jpg', 'new_immigrant-m-b-2.jpg']
        };

        // Schengen Visa
        this.SchengenVisa = {
            $desktop_vertical: ['schengen_visa-v-1.gif', 'schengen_visa-v-2.png', 'schengen_visa-v-3.jpg'],
            $desktop_horizontal: ['schengen_visa-h-1.gif', 'schengen_visa-h-2.gif', 'schengen_visa-h-3.jpg'],
            $desktop_square: ['schengen_visa-s-1.gif', 'schengen_visa-s-2.gif', 'schengen_visa-s-3.gif', 'schengen_visa-s-4.gif', 'schengen_visa-s-5.jpg'],
            $mobile_top: ['schengen_visa-m-t-1.jpg', 'schengen_visa-m-t-2.gif', 'schengen_visa-m-t-3.gif'],
            $mobile_bottom: ['schengen_visa-m-b-1.gif', 'schengen_visa-m-b-2.jpg', 'schengen_visa-m-b-3.gif']
        };

        // Travel Outside USA
        this.TravelOutside = {
            $desktop_vertical: ['travel_insurance_outside_usa-v-1.gif', 'travel_insurance_outside_usa-v-2.jpg', 'travel_insurance_outside_usa-v-3.jpg'],
            $desktop_horizontal: ['travel_insurance_outside_usa-h-1.gif', 'travel_insurance_outside_usa-h-2.gif', 'travel_insurance_outside_usa-h-3.gif'],
            $desktop_square: ['travel_insurance_outside_usa-s-1.gif', 'travel_insurance_outside_usa-s-2.jpg'],
            $mobile_top: ['travel_insurance_outside_usa-m-t-1.gif', 'travel_insurance_outside_usa-m-t-2.gif'],
            $mobile_bottom: ['travel_insurance_outside_usa-m-b-1.gif', 'travel_insurance_outside_usa-m-b-2.gif', 'travel_insurance_outside_usa-m-b-3.gif']
        };

        // Business Visa
        this.BusinessVisa = {
            $desktop_vertical: ['visitors_to_usa_business-v-1.jpg', 'visitors_to_usa_business-v-2.gif', 'visitors_to_usa_business-v-3.jpg'],
            $desktop_horizontal: ['visitors_to_usa_business-h-1.jpg', 'visitors_to_usa_business-h-2.gif', 'visitors_to_usa_business-h-3.gif'],
            $desktop_square: ['visitors_to_usa_business-s-1.jpg', 'visitors_to_usa_business-s-2.gif', 'visitors_to_usa_business-s-3.gif', 'visitors_to_usa_business-s-4.jpg', 'visitors_to_usa_business-s-5.gif', 'visitors_to_usa_business-s-6.gif'],
            $mobile_top: ['visitors_to_usa_business-m-t-1.jpg', 'visitors_to_usa_business-m-t-2.gif', 'visitors_to_usa_business-m-t-3.gif'],
            $mobile_bottom: ['visitors_to_usa_business-m-b-1.jpg', 'visitors_to_usa_business-m-b-2.jpg', 'visitors_to_usa_business-m-b-3.jpg']
        };

        // Young Adult
        this.YoungAdult = {
            $desktop_vertical: ['young_adult_mix-v-1.jpg', 'young_adult_mix-v-2.gif', 'young_adult_mix-v-3.jpg'],
            $desktop_horizontal: [],
            $desktop_square: [],
            $mobile_top: ['young_adult_mix-m-t-1.gif', 'young_adult_mix-m-t-2.gif', 'young_adult_mix-m-t-3.jpg'],
            $mobile_bottom: ['young_adult_mix-m-b-1.jpg', 'young_adult_mix-m-b-2.jpg', 'young_adult_mix-m-b-3.jpg']
        };

        // Scout AI - no Chinese artwork yet
        this.ScoutAI = {
            $desktop_vertical: [],
            $desktop_horizontal: [],
            $desktop_square: [],
            $mobile_top: [],
            $mobile_bottom: []
        };

        // Stable PreEx
        this.StablePreEx = {
            $desktop_vertical: ['stable-preex-160x600-v1.png'],
            $desktop_horizontal: ['stable-preex-970x90-v1.png'],
            $desktop_square: ['stable-preex-250x250-v1.png'],
            $mobile_top: ['stable-preex-300x50-v1.png'],
            $mobile_bottom: ['stable-preex-336x280-v1.png']
        };

        //flight
        this.Flight = {
            $desktop_vertical: ['flight-v-1.jpg'],
            $desktop_horizontal: ['flight-h-1.jpg'],
            $desktop_square: ['flight-s-1.jpg'],
            $mobile_top: ['flight-m-t-1.jpg'],
            $mobile_bottom: ['flight-m-b-1.jpg']
        }

        this.Marine = {
            $desktop_vertical: [],
            $desktop_horizontal: [],
            $desktop_square: [],
            $mobile_top: [],
            $mobile_bottom: []
        }

        // Trip Cancellation
        this.TripCancellation = {
            $desktop_vertical: [],
            $desktop_horizontal: [],
            $desktop_square: [],
            $mobile_top: [],
            $mobile_bottom: []
        }
    }

    let englishBanners = new ListOfEnglishBanners();
    
    if(language == 'zh') {
        englishBanners = new ListOfChineseBanners();
        folderLocation.rootFolder += 'zh/';
    }

    if(language == 'es') {
        englishBanners = new ListOfSpanishBanners();
        folderLocation.rootFolder += 'es/';
    }

    let verticalBanners = [];
    let horizontalBanners = [];
    let squareBanners = [];
    let mobileTopBanners = [];
    let mobileBottomBanners = [];

    // Banner slot -> utm_campaign label. Every section numbers its own banners per slot.
    let bannerSlots = [
        { key: '$desktop_vertical', campaign: 'Vertical' },
        { key: '$desktop_horizontal', campaign: 'Horizontal' },
        { key: '$desktop_square', campaign: 'square' },
        { key: '$mobile_top', campaign: 'MobileTop' },
        { key: '$mobile_bottom', campaign: 'MobileBottom' }
    ];

    /**
     * Turns a section's bare file names into { imgPath, navigation } pairs. Both the artwork
     * folder and the destination page are looked up per section, so a section such as Scout AI
     * links to its own page instead of an insurance category page.
     */
    function resolveBannerPaths (section) {
        bannerSlots.forEach(slot => {
            englishBanners[section][slot.key] = englishBanners[section][slot.key].map((e, index) => {
                let imgPath = folderLocation.rootFolder + folderLocation[section] + '/' + e;
                let navigation = insubuyPath.rootPath + insubuyPath[language][section] + '/?utm_source=immihelp&utm_medium=' + section + '&utm_campaign=' + slot.campaign + (index + 1);
                return {
                    imgPath: imgPath,
                    navigation: navigation
                };
            });
        });
    }

    // Concat multiple arrays to one array
    function addSectionToRotation (section) {
        verticalBanners = verticalBanners.concat(englishBanners[section]["$desktop_vertical"]);
        verticalBanners.shuffleArray();
        horizontalBanners = horizontalBanners.concat(englishBanners[section]["$desktop_horizontal"]);
        horizontalBanners.shuffleArray();
        squareBanners = squareBanners.concat(englishBanners[section]["$desktop_square"]);
        squareBanners.shuffleArray();
        mobileTopBanners = mobileTopBanners.concat(englishBanners[section]["$mobile_top"]);
        mobileTopBanners.shuffleArray();
        mobileBottomBanners = mobileBottomBanners.concat(englishBanners[section]["$mobile_bottom"]);
        mobileBottomBanners.shuffleArray();
    }

    for(let i = 0 ; i < selectedCategories.length ; i++) {

        if (selectedCategories.length > 1 && selectedCategories.indexOf('VisitorsToUSA') > -1 && selectedCategories[i] != 'VisitorsToUSA') {
            // Splicing up all the images in the array and keep only one so that visitors ads are targeted more than others.
            if(selectedCategories.length > 2)  {
                englishBanners[selectedCategories[i]]["$desktop_vertical"].splice(1, (englishBanners[selectedCategories[i]]["$desktop_vertical"].length - 1));
            } else {
                englishBanners[selectedCategories[i]]["$desktop_vertical"].splice(2, (englishBanners[selectedCategories[i]]["$desktop_vertical"].length - 1));
            }
        }
        
        // Setting Folderpath
        resolveBannerPaths(selectedCategories[i]);

        addSectionToRotation(selectedCategories[i]);
    }

    // Mix the Scout AI banners into the rotation of the visitors-to-usa family of sections. They
    // are resolved as their own section, so they keep their own destination URL and utm_medium
    // while the surrounding banners keep pointing at the category page.
    if (englishBanners[scoutAiSection] && selectedCategories.indexOf(scoutAiSection) === -1 &&
        selectedCategories.some(category => scoutAiHostSections.indexOf(category) > -1)) {
        resolveBannerPaths(scoutAiSection);
        addSectionToRotation(scoutAiSection);
    }

    // Same for the Stable PreEx banners, which point at the pre-existing condition coverage guide.
    if (englishBanners[stablePreexSection] && selectedCategories.indexOf(stablePreexSection) === -1 &&
        selectedCategories.some(category => stablePreexHostSections.indexOf(category) > -1)) {
        resolveBannerPaths(stablePreexSection);
        addSectionToRotation(stablePreexSection);
    }

    // Window object to see which ads are targeted.
    window.revenueTargeted = verticalBanners;

    let choiceOfVerticalBanner = verticalBanners[generateRandomNumber(0, (verticalBanners.length - 1))];
    let $verticalBanner = getSelector('.vertical-banner');
    if($verticalBanner && choiceOfVerticalBanner) {
        getSelector('.vertical-banner a').href = choiceOfVerticalBanner.navigation;
        const vertCanvas = getSelector('.vertical-banner canvas');
        vertCanvas.width = 154;
        vertCanvas.height = 578;
        vertCanvas.style.backgroundImage = `url('${choiceOfVerticalBanner.imgPath}')`;
    }

    let choiceOfHorizontalBanner = horizontalBanners[generateRandomNumber(0, (horizontalBanners.length - 1))];
    let $horizontalBanner = getSelector('.horizontal-banner') 
    if($horizontalBanner && choiceOfHorizontalBanner) {
        getSelector('.horizontal-banner a').href = choiceOfHorizontalBanner.navigation;
        const canvasBanner = getSelector('.horizontal-banner canvas');
        canvasBanner.setAttribute('width', 970);
        canvasBanner.setAttribute('height', 90);
        canvasBanner.style.backgroundImage = `url('${choiceOfHorizontalBanner.imgPath}'`;
    }

    let choiceOfHorizontalBanner_footer = horizontalBanners[generateRandomNumber(0, (horizontalBanners.length - 1))];
    let $horizontalBanner_footer = getSelector('.horizontal-banner.footer-vilab') 
    if($horizontalBanner_footer && choiceOfHorizontalBanner_footer) {
        getSelector('.horizontal-banner.footer-vilab a').href = choiceOfHorizontalBanner_footer.navigation;
        const canvasBanner = getSelector('.horizontal-banner.footer-vilab canvas');
        canvasBanner.setAttribute('width', 970);
        canvasBanner.setAttribute('height', 90);
        canvasBanner.style.backgroundImage = `url('${choiceOfHorizontalBanner_footer.imgPath}'`;
    }

    let choiceOfSquareBanner = squareBanners[generateRandomNumber(0, (squareBanners.length - 1))];
    let $squareBanner = getSelector('.square-banner');
    if($squareBanner && choiceOfSquareBanner) {
        getSelector('.square-banner a').href = choiceOfSquareBanner.navigation;
        const canvasBanner = getSelector('.square-banner canvas');
        canvasBanner.setAttribute('width', 250);
        canvasBanner.setAttribute('height', 250);
        canvasBanner.style.backgroundImage = `url('${choiceOfSquareBanner.imgPath}'`;
    }

    let $stickySquareBanner = getSelector('.c-Sticky-adv .square-banner');
    if ($stickySquareBanner && choiceOfSquareBanner) {
        getSelector('.c-Sticky-adv .square-banner a').href = choiceOfSquareBanner.navigation;
        const canvasBanner = getSelector('.c-Sticky-adv .square-banner img');
        canvasBanner.setAttribute('width', 200);
        canvasBanner.setAttribute('height', 200);
        canvasBanner.style.backgroundImage = `url('${choiceOfSquareBanner.imgPath}')`;
    }

    // Overwrite square ads to widgets if one is selected
    let frameEnabled = false;
    if (categoryAds.indexOf('Visitors To USA (Widget)') > -1) {
        $squareBanner.innerHTML = '<iframe src="https://immihelp.brokersnexus.com/widget1/visitors-insurance/?aid=immihelp" width="100%" style="height: 450px; border: 0;"></iframe>';
        if ($stickySquareBanner) $stickySquareBanner.innerHTML = '<iframe src="https://immihelp.brokersnexus.com/widget1/visitors-insurance/?aid=immihelp" width="100%" style="height: 450px; border: 0;"></iframe>';
        frameEnabled = true;
    } else if (categoryAds.indexOf('Schengen Visa Insurance (Widget)') > -1) {
        $squareBanner.innerHTML = '<iframe src="https://immihelp.brokersnexus.com/widget1/schengen-visa-insurance/?aid=immihelp" width="100%" style="height: 350px; border: 0;"></iframe>';
        if ($stickySquareBanner) $stickySquareBanner.innerHTML = '<iframe src="https://immihelp.brokersnexus.com/widget1/schengen-visa-insurance/?aid=immihelp" width="100%" style="height: 350px; border: 0;"></iframe>';
        frameEnabled = true;
    }

    let choiceOfMobileTopBanner = mobileTopBanners[generateRandomNumber(0, (mobileTopBanners.length - 1))];
    let $mobileTopBanner = getSelector('.mobile-banner');
    if($mobileTopBanner) {
        getSelector('.mobile-banner a').href = choiceOfMobileTopBanner.navigation;
        const canvasBanner = getSelector('.mobile-banner canvas');
        canvasBanner.setAttribute('width', 437);
        canvasBanner.setAttribute('height', 73);
        canvasBanner.style.backgroundImage = `url('${choiceOfMobileTopBanner.imgPath}'`;
    }

    let choiceOfMobileBottomBanner = mobileBottomBanners[generateRandomNumber(0, (mobileBottomBanners.length - 1))];
    let $mobileBottomBanner = getSelector('.footer-vilab .square-banner');
    if($mobileBottomBanner) {
        const $mobileBottomBannerLink = getSelector('.footer-vilab .square-banner a');
        if ($mobileBottomBannerLink) {
            $mobileBottomBannerLink.href = choiceOfMobileBottomBanner.navigation;
            const canvasBanner = getSelector('.footer-vilab .square-banner canvas');
            canvasBanner.setAttribute('width', 336);
            canvasBanner.setAttribute('height', 280);
            canvasBanner.style.backgroundImage  = `url('${choiceOfMobileBottomBanner.imgPath}'`;
        }
    }

    let choiceOfRectangleBanner = mobileBottomBanners[generateRandomNumber(0, (mobileBottomBanners.length - 1))];
    let $rectangleBanner = getSelector('.rectangle-banner');
    if ($rectangleBanner) {
        getSelector('.rectangle-banner a').href = choiceOfRectangleBanner.navigation;
        const canvasBanner = getSelector('.rectangle-banner canvas');
        canvasBanner.setAttribute('width', 336);
        canvasBanner.setAttribute('height', 280);
        canvasBanner.style.backgroundImage = `url('${choiceOfRectangleBanner.imgPath}')`;
    }
    
    /**
     * To render banner ads in btw the page.
     */
    if(window.immiObj.homePage) {
        // if home page
        let englishBanners = new ListOfEnglishBanners();
    
        if(language == 'zh') {
            englishBanners = new ListOfChineseBanners();            
        }

        if(language == 'es') {
            englishBanners = new ListOfSpanishBanners();            
        }
        
        // Sections that ride along in another category's home page slots, with the categories they host in.
        const rideAlongSections = [
            { section: scoutAiSection, hosts: scoutAiHostSections },
            { section: stablePreexSection, hosts: stablePreexHostSections }
        ];

        /**
         * Picks which section a home page slot draws from: the slot's own category, or one of the
         * ride-along sections (Scout AI, Stable PreEx) when the category is one they ride along with.
         * Weighted by how many banners each section has for that slot, so they keep the same share
         * they have elsewhere.
         */
        function pickSectionForSlot (categoryType, slotKey) {
            if (!englishBanners[categoryType]) return categoryType;
            const candidates = [{ section: categoryType, count: englishBanners[categoryType][slotKey].length }];
            rideAlongSections.forEach(rideAlong => {
                if (rideAlong.hosts.indexOf(categoryType) === -1 || !englishBanners[rideAlong.section]) return;
                const count = englishBanners[rideAlong.section][slotKey].length;
                if (count) candidates.push({ section: rideAlong.section, count: count });
            });
            const total = candidates.reduce((sum, candidate) => sum + candidate.count, 0);
            if (candidates.length === 1 || !total) return categoryType;
            let pick = generateRandomNumber(0, (total - 1));
            for (let i = 0; i < candidates.length; i++) {
                if (pick < candidates[i].count) return candidates[i].section;
                pick -= candidates[i].count;
            }
            return categoryType;
        }

        function homePageLink (section, index) {
            return insubuyPath.rootPath + insubuyPath[language][section] + '/?utm_source=immihelp&utm_medium=' + section + '&utm_campaign=HomePage' + index;
        }

        let allBanners = document.querySelectorAll('.horizontal-banner') || [];
        if (allBanners) allBanners = Array.from(allBanners);
        else allBanners = [];
        let choiceOfMobileBanner;
        let $mobileBanner;
        allBanners.forEach(e=>{
            const categoryType = e.getAttribute("data-category");
            const id = e.id;
            let mobileBanners = [];
            let $aLink = null;
            let $imgElm = null;
            if (id) {
                $aLink = document.querySelector('#' + id + ' a');
                $imgElm = document.querySelector('#' + id + ' canvas');
                const horizontalSection = pickSectionForSlot(categoryType, "$desktop_horizontal");
                var randomNum = generateRandomNumber(0, (englishBanners[horizontalSection]["$desktop_horizontal"].length - 1));
                var srcLink = homePageLink(horizontalSection, randomNum);
                if ($aLink) $aLink.setAttribute('href', srcLink);
                if ($imgElm) {
                    $imgElm.setAttribute('width', 970);
                    $imgElm.setAttribute('height', 90);
                    $imgElm.style.backgroundImage = `url('${folderLocation.rootFolder + folderLocation[horizontalSection] + '/' + englishBanners[horizontalSection]["$desktop_horizontal"][randomNum]}')`;
                }

                let mobileSection = categoryType;
                if (categoryType) {
                    const mobileSlot = categoryType == 'GroupTravel' ? "$mobile_bottom" : "$mobile_top";
                    mobileSection = pickSectionForSlot(categoryType, mobileSlot);
                    mobileBanners = mobileBanners.concat(englishBanners[mobileSection][mobileSlot]);
                    mobileBanners.shuffleArray();
                    choiceOfMobileBanner = mobileBanners[generateRandomNumber(0, (mobileBanners.length - 1))];
                    $mobileBanner = getSelector('.mobile-banner');
                }

                if ($mobileBanner) {
                    getSelector('#' + id + ' .mobile-banner a').href = homePageLink(mobileSection, randomNum);
                    const mbCanvas = getSelector('#' + id + ' .mobile-banner canvas');
                    if (mbCanvas) {
                        mbCanvas.setAttribute('width', 437);
                        mbCanvas.setAttribute('height', 73);
                        mbCanvas.style.backgroundImage = `url('${folderLocation.rootFolder + folderLocation[mobileSection] + '/' + choiceOfMobileBanner}')`;
                    }
                }
            }
        })
    }
